<template>
  <div class="conteudo">
    <b-container class="py-md-5">
        <b-row>
            <b-col class="col-12 col-lg-6 py-3 py-md-5 d-none d-md-block">
                <h4 class="mb-0 text-white">Cadastre</h4>
                <h3 class="mt-0 color-azul-1">SUA CONTA</h3>
                <h5 class="pt-2 fw-300">
                    Crédito rápido e descomplicado, com desconto direto na folha de pagamento, exclusivo para profissionais da ASPEB com carteira assinada.
                </h5>
            </b-col>
            <b-col class="col-12 col-lg-6 py-3 py-md-5 text-right d-none d-md-block" align-self="end">
                <template>
                    <b-breadcrumb class="justify-content-end">
                        <b-breadcrumb-item href="http://www.finlev.com.br/">Inicial</b-breadcrumb-item>
                        <b-breadcrumb-item active>Página em branco</b-breadcrumb-item>
                    </b-breadcrumb>
                </template>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="col-12 py-5">
                <div class="quadro-branco">
                    CONTEÚDO
                </div>
            </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
